// Inside the Android / iOS app (Capacitor loads the live site in a WebView and
// injects its bridge) a few things should behave like an app, not a web page.
// Nothing here runs in a plain browser.

type CapacitorBridge = {
  isNativePlatform?: () => boolean;
  getPlatform?: () => string;
  Plugins?: {
    App?: { addListener(event: "backButton", cb: (e: { canGoBack: boolean }) => void): unknown; exitApp(): Promise<void> };
    StatusBar?: { setStyle(o: { style: "DARK" | "LIGHT" }): Promise<void>; setBackgroundColor(o: { color: string }): Promise<void> };
  };
};

const bridge = () => (window as Window & { Capacitor?: CapacitorBridge }).Capacitor;

/** True inside the native app. Also true by user agent, before the bridge is ready. */
export const inApp = () => !!bridge()?.isNativePlatform?.() || /cscoach-app/.test(navigator.userAgent);

export function setupNative() {
  const cap = bridge();
  if (!cap?.isNativePlatform?.()) return;
  // Android's back button walks the app's history and leaves at the root.
  cap.Plugins?.App?.addListener("backButton", ({ canGoBack }) => {
    if (canGoBack && window.history.length > 1) window.history.back();
    else void cap.Plugins?.App?.exitApp();
  });
  void cap.Plugins?.StatusBar?.setStyle({ style: "DARK" });
  if (cap.getPlatform?.() === "android") void cap.Plugins?.StatusBar?.setBackgroundColor({ color: "#0a0e13" });
  document.documentElement.classList.add("in-app");
}
